var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.flashMessage)?_c('v-alert',{attrs:{"type":_vm.flashType,"dismissible":""},on:{"input":_vm.clearFlash}},[_vm._v(" "+_vm._s(_vm.flashMessage)+" ")]):_vm._e(),_c('QuotazioneRCASearch',{on:{"flash":_vm.handleFlash,"error":_vm.handleError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }